import React from 'react';

const investmentOne = (props) => {
  return (
    <div>
      <label htmlFor="investment1">Expense Ratio (%)</label>
      <br />
      <input
        type="number"
        name="investment1"
        placeholder="Enter expense ratio..."
        onChange={props.updateInputs}
      ></input>
    </div>
  );
};

export default investmentOne;
